export default __webpack_public_path__ + "static/media/innovator-hypothesis.7aa23de7.svg";